import { render, staticRenderFns } from "./UpdateContact.vue?vue&type=template&id=039e0194&"
import script from "./UpdateContact.vue?vue&type=script&lang=js&"
export * from "./UpdateContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports